import { combineEpics } from 'redux-observable';
import { Observable } from 'rxjs';

import * as ActionCreators from '../actions/ActionCreators';
import * as ActionTypes from '../actions/ActionTypes';


// set up standard video event observables
const playerEventsEpic = (action$, store, { player }) => Observable.merge(  // fires each event in turn as it occurs
    Observable.fromEvent(player, 'canplaythrough').mapTo(ActionCreators.playerEventCanPlayThrough()),
    Observable.fromEvent(player, 'durationchange').mapTo(ActionCreators.playerEventDurationChange()),
    Observable.fromEvent(player, 'ended').mapTo(ActionCreators.playerEventEnded()),
    Observable.fromEvent(player, 'error').map((e, count) => ActionCreators.playerEventError(count)),
    Observable.fromEvent(player, 'fullscreenchange').mapTo(ActionCreators.playerEventFullscreenChange()),
    Observable.fromEvent(player, 'loadeddata').mapTo(ActionCreators.playerEventLoadedData()),
    Observable.fromEvent(player, 'pause').mapTo(ActionCreators.playerEventPause()),
    Observable.fromEvent(player, 'play').map((e, count) => ActionCreators.playerEventPlay(count)),
    Observable.fromEvent(player, 'playing').mapTo(ActionCreators.playerEventPlaying()),
    Observable.fromEvent(player, 'ready').mapTo(ActionCreators.playerEventReady()),
    Observable.fromEvent(player, 'timeupdate').mapTo(ActionCreators.playerEventTimeUpdate()),
    Observable.fromEvent(player, 'volumechange').mapTo(ActionCreators.playerEventVolumeChange()),
    Observable.fromEvent(player, 'waiting').mapTo(ActionCreators.playerEventWaiting()),
);


// set up hls video event observables
const playerEventReadyEpic = (action$, store, { player }) => action$
    .ofType(ActionTypes.PLAYER_EVENT_READY)
    .switchMap(() => Observable.merge(
        Observable.fromEvent(player.tech_, 'hlsMediaAttached', (e, data) => data).map((data) => ActionCreators.hlsEventMediaAttached(data)),
        Observable.fromEvent(player.tech_, 'hlsManifestParsed', (e, data) => data).map((data) => ActionCreators.hlsEventManifestParsed(data)),
        Observable.fromEvent(player.tech_, 'hlsLevelLoaded', (e, data) => data).map((data) => ActionCreators.hlsEventLevelLoaded(data)),
        Observable.fromEvent(player.tech_, 'hlsLoadError', (e, data) => data).map((data) => ActionCreators.hlsEventLoadError(data))
        .ignoreElements(),
    ));


// set the current time to first time when a video starts playing
// only do this is first time hasn't been set
const setAutoplayEpic = (action$, store, { player }) => action$
    .ofType(ActionTypes.PLAYER_EVENT_PLAYING)
    .filter(() => !player.autoplay()) // only set if autoplay if off
    .do(() => player.autoplay(true)) // sets autoplay to true so content starts right up after ads
    .ignoreElements(); // get current time and set it to first time


// listens for video end and fires custom finished event if no ads are up next
const triggerFinishedAfterEndEvent = (action$, store, { player, ads }) => action$
    .ofType(ActionTypes.PLAYER_EVENT_ENDED)
    .filter(() => !store.getState().player.adPlaying) // only when ad isn't playing
    .filter(() => !ads.postrolls.length) // if no videos
    .map(() => store.getState().videoSource)
    .do(videoSource => player.trigger('finished', videoSource)) // fire finished event if no more ads to play
    .ignoreElements();


// listens for postroll end and fires custom finished event
const triggerFinishedAfterPostroll = (action$, store, { player }) => action$
    .ofType(ActionTypes.ADS_POSTROLL_END)
    .map(() => store.getState().videoSource)
    .do(videoSource => player.trigger('finished', videoSource))
    .ignoreElements();


// const onDestroyEpic = (action$, store, { player }) => action$
//     .ofType(ActionTypes.DESTROY)
//     .ignoreElements();


export default combineEpics(
    playerEventReadyEpic,
    playerEventsEpic,
    setAutoplayEpic,
    triggerFinishedAfterEndEvent,
    triggerFinishedAfterPostroll,
);


// WEBPACK FOOTER //
// ./src/player/epics.js